import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';

import { getAPIIds, handleDateTimePost } from '../../../../Functions/apis';
import axiosInstance from '../../../../services/AxiosInstance';
import PreCompanypostjobs from './PreCompanypostjobs';

const ConCompanyPostJobs = () => {

    const { id } = useParams();

    const [input, setInput] = useState({});
    const [show, setShow] = useState();
    const [, forceUpdate] = useState()

    useEffect(() => {
        axiosInstance(
            "institution/status/", {
            method: "GET",
            data: {}
        }).then(res => {
            setShow(res?.data);
        })

        id &&
            axiosInstance(
                `post-jobs/${id}/`, {
                method: "GET",
            }).then(res => {
                setInput(res.data);
            })
        // eslint-disable-next-line
    }, []);

    const simpleValidator = useRef(new SimpleReactValidator());
    const history = useHistory();

    const handleInput = (e, name, type, url) => {
        if (['dropdown'].includes(type)) {
            setInput({ ...input, [name]: e });
            if (name === 'country') setInput({ ...input, [name]: e, 'state': [], 'city': [] })
            if (name === 'state') setInput({ ...input, [name]: e, 'city': [] })
        } else setInput({ ...input, [e.target.name]: e.target.value });
        if (type === 'dropdown') {
            var newVal = Array.isArray(e) && e?.filter(res => res.__isNew__ === true);
            if (newVal?.length > 0) {
                axiosInstance(
                    url, {
                    method: "POST",
                    data: { "name": newVal?.[0]?.name }
                }).then(res => {
                    newVal[0].id = +(res.data?.id);
                    delete newVal[0]['__isNew__'];
                    setInput({ ...input, [name]: e });
                }).catch(err => {
                    swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
                })
            } else if (e.__isNew__) {
                axiosInstance(
                    `${url}/`, {
                    method: "POST",
                    data: { name: e.name }
                }).then(res => {
                    setInput({ ...input, [name]: res.data });
                }).catch(err => {
                    swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
                })
            }
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let formValid = simpleValidator.current.allValid();
        if (!formValid) {
            simpleValidator.current.showMessages();
            forceUpdate(1);
        } else {
            let data = { ...input };
            if (data?.start_time > data?.end_time) {
                swal("", "Start time must be less than End time", "error", { button: "OK" });
                return false;
            }
            data['title'] = data?.title?.id;
            data['category'] = getAPIIds(data?.category);
            data['skills'] = getAPIIds(data?.skills);
            data['career_level'] = data?.career_level?.id;
            data['country'] = getAPIIds(data?.country);
            data['state'] = getAPIIds(data?.state);
            data['city'] = getAPIIds(data?.city);
            data['preferred_gender'] = data?.preferred_gender?.id;
            data['preferred_qualification'] = getAPIIds(data?.preferred_qualification);
            data['salary_per'] = data?.salary_per?.id;
            data['type'] = getAPIIds(data?.type);
            data['start_time'] = handleDateTimePost(new Date(data.start_time));
            data['end_time'] = handleDateTimePost(new Date(data.end_time));
            delete data.job_status;
            delete data.created_by;
            delete data.institution;
            delete data.updated_by;
            var url = input?.id ? `post-jobs/${input.id}/` : `post-jobs/`;
            var method = input?.id ? "PUT" : "POST";
            axiosInstance(url, { method: method, data: data })
                .then(res => {
                    if (res?.status === 201 || res?.status === 200) {
                        swal("", `Job ${res?.status === 200 ? "updated" : "created"} successfully`, "success", { button: "Ok!", });
                        history.push("/employer/company-manage-job");
                    }
                }).catch(err => {
                    swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
                })
        }
    }

    let datas = {
        id,
        input,
        simpleValidator,
        handleInput,
        show,
        handleSubmit
    }

    return (
        <PreCompanypostjobs {...datas} />
    );
};

export default ConCompanyPostJobs;